export default {
  slug: "amper",
  code: "AMP",
  label: "Amper",
  logoFamily: "jb",
};
